import { lazyFetchSearchAnswer, lazyInitializeData } from 'owa-search-answer-deeplink';
import { action } from 'satcheljs/lib/legacy';

export const deepLinkSearchAnswerRouteHandler = action('deepLinkSearchAnswerRouteHandler')(
    async function deepLinkSearchAnswerRouteHandler() {
        await lazyInitializeData.importAndExecute();
        lazyFetchSearchAnswer.importAndExecute();
    }
);
